import React from 'react'
import {
   AIFinancialIcon,
   AIPoweredSalesIcon,
   ContinuousSupportIcon,
   CustomFintechIcon,
   CustomOnlineStoreIcon,
   ScalableSolutionsIcon,
   SeamlessIntegrationIcon,
   SecureTransactionsIcon,
} from '@/svgs'
import { WhyChooseOur } from '@/components'

const featureCards = [
   {
      title: 'Custom Online Store',
      subtitle: 'Tailored Solutions for E-commerce Brands',
      description:
         'To ensure smooth online buying, we create unique e-commerce platforms, such as D2C shops, B2B marketplaces, and subscription-based companies.',
      icon: <CustomOnlineStoreIcon />,
   },
   {
      title: 'AI-Powered Sales Optimization',
      subtitle: 'Smart Recommendations and Insights',
      description:
         'We implement AI-driven sales optimization tools that analyze customer behavior, optimize pricing strategies, and enhance user engagement, boosting revenue generation.',
      icon: <AIPoweredSalesIcon />,
   },
   {
      title: 'Secure & Compliant Transactions',
      subtitle: 'Fraud Prevention and Payment Security',
      description:
         'We help you stay compliant with PCI-DSS, GDPR, and eCommerce standards by adding secure logins, encrypting sensitive data, and using smart tools to catch fraud before it becomes a problem.',
      icon: <SecureTransactionsIcon />,
   },
   {
      title: 'Seamless Third-Party Integrations',
      subtitle: 'ERP, CRM, and Payment Gateways',
      description:
         'We build eCommerce platforms that run in the cloud and connect with the tools you already use like inventory systems, shipping providers, CRMs, ERPs, and digital wallets. Everything works together in one place so you are not jumping between disconnected systems.',
      icon: <SeamlessIntegrationIcon />,
   },
   {
      title: 'Scalable Cloud-Based Solutions',
      subtitle: 'High-Performance and Omnichannel Support',
      description:
         'Our cloud-powered e-commerce solutions provide real-time data synchronization, multi-store management, and global scalability, enabling business expansion.',
      icon: <ScalableSolutionsIcon />,
   },
   {
      title: 'Continuous Support & Enhancements',
      subtitle: 'Maintenance and Feature Upgrades',
      description:
         'We offer 24x7 technical support, security patches, and feature updates so that e-commerce solutions are competitive and future-proof.',
      icon: <ContinuousSupportIcon />,
   },
]

function EcoWhyChoose() {
   return (
      <>
         <WhyChooseOur
            title={'Why Choose Our E-commerce Development Services?'}
            desc={
               'We create secure, scalable, and conversion-driven e-commerce solutions designed to improve shopping experiences, optimize backend processes, and sustain long-term growth.Here’s why businesses trust us:'
            }
            cardData={featureCards}
         />
      </>
   )
}

export default EcoWhyChoose
